"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var APDUStatusCode = /** @class */ (function () {
    function APDUStatusCode() {
    }
    // "OK" status word sent in response to command (0x9000)
    APDUStatusCode.SUCCESSFUL = Uint8Array.from([0x90, 0x00]);
    // CRC or MAC does not match data
    APDUStatusCode.INVALID_CRC_OR_MAC = Uint8Array.from([0x91, 0x1E]);
    return APDUStatusCode;
}());
exports.APDUStatusCode = APDUStatusCode;
